/** @module components/paywalls */
import React from 'react';
import { defineMessages } from 'react-intl';
import { useLoc } from 'app/utils/hooks';
import { Loc } from 'app/components/helpers';
import ModalWrapper from 'app/components/modals/ModalWrapper';
import { openIntercom } from 'app/utils/intercom';
import styles from './styles.module.scss';

type PropsDef = {
  show?: boolean;
  error?: string;
  onClose?: () => void;
};

export default function UpgradeErrorModal(props: PropsDef) {
  const { formatMessage } = useLoc();

  const handleClick = () => {
    (window as any).location = '/account/billing_info';
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <ModalWrapper
      isOpen={props.show}
      onRequestClose={handleClose}
      title={formatMessage(locale.header_title)}
    >
      <div className={styles.upgradeErrorModal}>
        <div className={styles.upper}>
          <div className={styles.error}>
            {props.error}
          </div>
        </div>

        <div className={styles.lower}>
          <button className="btn btn-secondary pull-left" onClick={openIntercom}>
            <Loc value={locale.contact_support} />
          </button>

          <button className="btn btn-primary pull-right" onClick={handleClick}>
            <Loc value={locale.update_billing_info_button} />
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}

const locale = defineMessages({
  header_title: { id: 'upgarde-error-modal.title.header', defaultMessage: "Upgrade error" },
  contact_support: { id: 'upgarde-error-modal.button.contact-support', defaultMessage: "Contact Support" },
  update_billing_info_button: { id: 'upgarde-error-modal.button.update-billing-info', defaultMessage: "Update Billing Info" },
});
